import React from 'react';

//Material UI
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { useReportes } from './ReportesContex';

export default function Menu() {
    const { selectedIndex, setSelectedIndex } = useReportes();

    const handleListItemClick = (event, index) => {
        event.preventDefault();
        setSelectedIndex(index);
    };

    return (
        <List component="nav" style={{ width: '100%' }}>
            {process.env.REACT_APP_ALLOW_REPORTS_INFORME_PRODUCCION === 'true' && (
                <ListItem
                    button
                    selected={selectedIndex === 8}
                    onClick={(event) => handleListItemClick(event, 8)}
                >
                    <ListItemText primary="Informe de producción" />
                </ListItem>
            )}
            {process.env.REACT_APP_ALLOW_REPORTS_PRODUCTION_REPORT === 'true' && (
                <ListItem
                    button
                    selected={selectedIndex === 1}
                    onClick={(event) => handleListItemClick(event, 1)}
                >
                    <ListItemText primary="Informe de producción" />
                </ListItem>
            )}
            {process.env.REACT_APP_ALLOW_REPORTS_OPERACION === 'true' && (
                <ListItem
                    button
                    selected={selectedIndex === 9}
                    onClick={(event) => handleListItemClick(event, 9)}
                >
                    <ListItemText primary="Reporte de operación" />
                </ListItem>
            )}
            {process.env.REACT_APP_ALLOW_REPORTS_CORRIDAS_REPORT === 'true' && (
                <ListItem
                    button
                    selected={selectedIndex === 2}
                    onClick={(event) => handleListItemClick(event, 2)}
                >
                    <ListItemText primary="Informe Corridas" />
                </ListItem>
            )}
            {process.env.REACT_APP_ALLOW_REPORTS_LOST_TIMES === 'true' && (
                <ListItem
                    button
                    selected={selectedIndex === 3}
                    onClick={(event) => handleListItemClick(event, 3)}
                >
                    <ListItemText primary="Tiempos Perdidos" />
                </ListItem>
            )}
            {process.env.REACT_APP_ALLOW_REPORTS_MTBF_MTTR === 'true' && (
                <ListItem
                    button
                    selected={selectedIndex === 4}
                    onClick={(event) => handleListItemClick(event, 4)}
                >
                    <ListItemText primary="Indicadores" />
                </ListItem>
            )}
            {process.env.REACT_APP_ALLOW_REPORTS_TIMELINE === 'true' && (
                <ListItem
                    button
                    selected={selectedIndex === 5}
                    onClick={(event) => handleListItemClick(event, 5)}
                >
                    <ListItemText primary="Línea de tiempo" />
                </ListItem>
            )}
            {process.env.REACT_APP_ALLOW_REPORTS_INFORME2 === 'true' && (
                <ListItem
                    button
                    selected={selectedIndex === 7}
                    onClick={(event) => handleListItemClick(event, 7)}
                >
                    <ListItemText primary="Pareto — Fallas" />
                </ListItem>
            )}
        </List>
    );
}
